import { render, staticRenderFns } from "./PostItem.vue?vue&type=template&id=18774ce0&scoped=true&"
import script from "./PostItem.vue?vue&type=script&lang=js&"
export * from "./PostItem.vue?vue&type=script&lang=js&"
import style0 from "./PostItem.vue?vue&type=style&index=0&id=18774ce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18774ce0",
  null
  
)

export default component.exports